import React from 'react'

export default function BaseComponent(WrappedComponent, name) {
    return class extends React.Component {
        render() {
            return <WrappedComponent {...this.props} />
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/basecomponent/BaseComponent.js